import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gtbuyspreadsheet.pro';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'GTBuy Spreadsheet',
  url: siteUrl,
  description: 'Smart sourcing and order management spreadsheet tools for resellers. Compare GTBuy, Kakobuy, and Superbuy spreadsheets.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'GTBuy Spreadsheet',
  url: siteUrl,
  description: 'Smart sourcing and order management spreadsheet tools for resellers worldwide. Compare GTBuy, Kakobuy, and Superbuy spreadsheets for ecommerce, dropshipping, and logistics.',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/54d75be42d5913aa14ca64dd22e5d3e1.jpeg',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleSection />
        <TrustSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}